import httpClient from "Api/httpClient";

const END_POINT = "/customers";

const getCustomerAddresses = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;

    const GET_END_POINT = END_POINT + "/" + payload.body.company_id + "/addresses";
    return httpClient.get(GET_END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getCustomerAddress = (company_id, entity_addresses_id) => {
    if (!entity_addresses_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + company_id + "/addresses/" + entity_addresses_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createCustomerAddresses = (payload, company_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const POST_END_POINT = END_POINT + "/" + company_id + "/addresses";
    return httpClient.post(POST_END_POINT, body);
};

const updateCustomerAddresses = (payload, company_id, entity_addresses_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + company_id + "/addresses/" + entity_addresses_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteCustomerAddresses = (entity_addresses_id) => {
    const DELETE_END_POINT = END_POINT + "/" + company_id + "/addresses/" + entity_addresses_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getCustomerAddresses, getCustomerAddress, createCustomerAddresses, updateCustomerAddresses, deleteCustomerAddresses };
